import { Injectable } from '@angular/core';

import { TableRepository } from '@database/workspace';
import { ErrorCodes, TableModel } from '@shared';
import { LoggingService } from '@shared/logging';
import { Observable } from 'rxjs';
import { catchError, first, map, tap } from 'rxjs/operators';
import { QueryParamsProvider } from '../../routing/services';
import { StandardTableProvider } from './standard-table.provider';

@Injectable()
export class StandardTableResolver {
	public constructor(
		private tableRepository: TableRepository,
		private loggingService: LoggingService,
		private standardTableProvider: StandardTableProvider,
		private queryParamsProvider: QueryParamsProvider
	) {}

	public resolve(): Observable<string> {
		return this.tableRepository.getTableMetadata$(this.queryParamsProvider.parentTableName).pipe(
			map((tableMetadata: TableModel) => (tableMetadata.standard_table ? tableMetadata.standard_table : null)),
			tap((standardTable: string) => (this.standardTableProvider.standardTableName = standardTable)),
			catchError((error) => {
				this.loggingService.error(ErrorCodes.NoStandardTable, error);
				throw new Error(`No Standard table defined for entity ${this.queryParamsProvider.parentTableName}`);
			}),
			first()
		);
	}
}
